<template>
    <div class="mc-report-view__table">
        <div class="row">
            <!-- Search -->
            <div class="col-md-12">
                <div class="mc-table-view">
                    <div id="tickets-table_filter" class="dataTables_filter text-md-end float-end">
                        <label class="d-inline-flex align-items-center mc-table-view__search">
                            <i class="mc-fa fas fa-search"></i>
                            <b-form-input v-model="filter" type="search" :placeholder="$t('global.search') + '...'"
                                class="ms-2" @input="searchData"></b-form-input>
                        </label>
                    </div>
                </div>
            </div>
            <!-- End search -->
        </div>

        <div class="table-responsive my-3 border border-1" v-if="fields.length > 0">
            <b-skeleton-wrapper :loading="isLoading">
                <template #loading>
                <b-card>
                    <b-skeleton-table
                    :rows="3"
                    :columns="fields.length"
                    :table-props="{ bordered: false, striped: true }"
                    >
                    </b-skeleton-table>
                </b-card>
                </template>
                <b-table
                class="datatables"
                :items="listData"
                :fields="fields"
                bordered
                responsive="lg"
                show-empty
                :per-page="perPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                :empty-text="$t('global.emptyTable')"
                >
                <template #cell(vehicleType)="data">
                    {{ data.item.vehicleManufacturer ? data.item.vehicleManufacturer : '-' }} /
                    {{ data.item.vehicleModel ? data.item.vehicleModel : '-' }} /
                    {{ data.item.vehicleType ? data.item.vehicleType : '-' }}
                </template>
                <template #cell(inTime)="data">
                    {{ data.item ? momentDateShortMonth(data.item.inTime) : '-' }}<br />
                    <span class="text-muted">{{
                    data.item ? momentTimeSeconds(data.item.inTime) : '-'
                    }}</span>
                </template>
                <template #cell(outTime)="data">
                    {{ data.item ? momentDateShortMonth(data.item.outTime) : '-' }}<br />
                    <span class="text-muted">{{
                    data.item ? momentTimeSeconds(data.item.outTime) : '-'
                    }}</span>
                </template>
                <template #cell(visitedGeofence)="data">
                    <template v-if="data.item">
                    <div
                        v-for="(chunk, index) in chunkedVisitedGeofence(data.item.visitedGeofence)"
                        :key="index"
                    >
                        {{ chunk }}
                        <br v-if="index < chunkedVisitedGeofence(data.item.visitedGeofence).length - 1" />
                    </div>
                    </template>
                    <template v-else> - </template>
                </template>
                </b-table>
            </b-skeleton-wrapper>
        </div>
        <div class="row mt-3" v-if="fields.length > 0">
            <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                        {{ $t('global.text.displays') }}
                        <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm" :options="pageOptions"
                            @input="changePerPage">
                        </b-form-select>
                        {{ $t('global.text.entries') }}.
                        <p>
                            {{ $t('global.text.display') }}
                            <strong>{{ totalRows > 0 ? (currentPage - 1) * perPage + 1 : 0 }}</strong> -
                            <strong>{{ Math.min(totalRows, currentPage * perPage) }}</strong>
                            {{ $t('global.object.of') }}
                            <strong>{{ totalRows }}</strong>
                        </p>
                    </label>
                </div>
            </div>
            <div class="col-sm-12 col-md-6">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination v-model="currentPage" :total-rows="totalRows == null ? rows : totalRows"
                            :per-page="perPage" @change="changePage">
                        </b-pagination>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { GET_REPORT_VEHICLE_OUTSIDE_GEOFENCE } from '@/services/api/report/report'
import moment from 'moment'
import { Helper, debounce } from '@/mixin/helper'
import { Export } from '@/mixin/export'
import { EXPORT_PDF_REPORT_VEHICLE_OUTSIDE_GEOFENCE } from '@/services/api/report/pdf'
import { EXPORT_EXCEL_REPORT_VEHICLE_OUTSIDE_GEOFENCE } from '@/services/api/report/excel'
moment.locale('id')

export default {
    name: 'SummaryVehicleOutsideGeofenceTable',
    mixins: [Helper, Export],
    data() {
        return {
            tableData: [],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterGeofence: 0,
            filterVehicle: [],
            filterOn: [],
            summaryVehicleOutsideGeofence: {
                summaryVehicleOutsideGeofence: {
                    data: [],
                },
            },
            fields: [],
            isLoading: false,
            fileName: '',
            openSection: false,
            periode: [],
            filteredItems: [],
            selectedData: [],
        }
    },
    computed: {
        /**
         * Total no. of records
         */
        rows() {
            return this.summaryVehicleOutsideGeofence.summaryVehicleOutsideGeofence.length
        },
        childFields() {
            const filteredData = this.fields.filter((obj) => {
                return obj.hasOwnProperty('children')
            })
            return filteredData
        },
        listData() {
            return this.summaryVehicleOutsideGeofence.summaryVehicleOutsideGeofence
        },
    },
    mounted() {
        // Set the initial number of items
        this.totalRows = this.summaryVehicleOutsideGeofence.summaryVehicleOutsideGeofence.length
    },
    methods: {
        /**
         * Search the table data with search input
         */
        formatTotalHours(totalHours) {
            const days = Math.floor(totalHours / 24)
            const remainingHours = totalHours % 24
            const formattedHours = `${String(remainingHours).padStart(2, '0')}:00:00`
            return `${days} days ${formattedHours}`
        },

        selectValues(data, key) {
            const result = []

            // Recursive helper function
            function selectHelper(obj) {
                const selectedValues = obj[key]
                if (selectedValues) {
                    result.push(selectedValues)
                }
            }

            data.forEach((obj) => selectHelper(obj))
            return result
        },

        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.filteredItems = filteredItems
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },

        changePerPage(perPage) {
            this.perPage = perPage
            this.currentPage = 1
            this.refreshData(this.periode, this.filterGeofence, this.filterVehicle, this.fields)
        },

        changePage(page) {
            this.currentPage = page
            this.refreshData(this.periode, this.filterGeofence, this.filterVehicle, this.fields)
        },

        searchData: debounce(function () {
            this.currentPage = 1
            this.refreshData(this.periode, this.filterGeofence, this.filterVehicle, this.fields)
        }, 500),

        refreshData(periode, filterGeofence, filterVehicle, fields) {
            this.summaryVehicleOutsideGeofence.summaryVehicleOutsideGeofence = []
            if (fields.length == 0) {
                this.summaryVehicleOutsideGeofence.summaryVehicleOutsideGeofence = []
                return
            }
            this.fields = fields
            this.isLoading = true
            this.periode = periode
            this.filterGeofence = filterGeofence
            this.filterVehicle = filterVehicle

            let geofenceId = 0
            if (filterGeofence !== undefined && filterGeofence.geofenceId > 0) {
                geofenceId = filterGeofence.geofenceId
            }

            let vehicleId = []
            if (filterVehicle !== undefined && filterVehicle.length > 0) {
                vehicleId = filterVehicle
            }

            let filterVar = {
                startDate: moment(periode[0] + ' 00:00:00.000').toISOString(),
                endDate: moment(periode[1] + ' 23:59:59.000').toISOString(),
                pagination: {
                    page: this.currentPage,
                    show: this.perPage,
                },
                search: this.filter || undefined,
                sortBy: 'outTime',
                sortType: 'asc',
                geofenceId,
                vehicleId,
            }

            this.selectedData = this.selectValues(fields, 'key')

            let self = this
            let getData = this.$apollo
                .query({
                    query: GET_REPORT_VEHICLE_OUTSIDE_GEOFENCE,
                    variables: {
                        filter: filterVar,
                    },
                    fetchPolicy: 'no-cache',
                })
                .then((res) => {
                    let data = res.data
                    self.totalRows =
                        data.summaryVehicleOutsideGeofence.summaryVehicleOutsideGeofence.pagination.total
                    if (self.totalRows === 0) {
                        self.summaryVehicleOutsideGeofence.summaryVehicleOutsideGeofence = []
                        self.isLoading = false
                        return []
                    }

                    self.summaryVehicleOutsideGeofence.summaryVehicleOutsideGeofence =
                        data.summaryVehicleOutsideGeofence.summaryVehicleOutsideGeofence.data
                    self.filteredItems = data.summaryVehicleOutsideGeofence.summaryVehicleOutsideGeofence.data

                    self.isLoading = false
                })

            return getData
        },

        openTable(periode, filterGeofence, filterVehicle, fields) {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.refreshData(periode, filterGeofence, filterVehicle, fields)
                    this.openSection = false
                }, 500)
            })
        },

        downloadToExcel(periode, filterGeofence, filterVehicle, fields) {
            let filterGeofences = {}
            if (filterGeofence !== undefined && filterGeofence.geofenceId > 0) {
                filterGeofences = {
                    geofenceId: filterGeofence.geofenceId,
                }
            }

            let filterVehicles = {}
            if (filterVehicle !== undefined && filterVehicle.length > 0) {
                filterVehicles = {
                    vehicleId: filterVehicle,
                }
            }

            let filterVar = {
                startDate: moment(periode[0] + ' 00:00:00.000').toISOString(),
                endDate: moment(periode[1] + ' 23:59:59.000').toISOString(),
                column: this.selectValues(fields, 'header'),
                subtitle: `Periode : ${moment(periode[0]).format("DD MMM YYYY")} - ${moment(periode[1]).format("DD MMM YYYY")}`,
                ...filterGeofences,
                ...filterVehicles,
            }

            let downloadProgress = {
                name: 'Kendaraan Keluar Geolokasi ' + moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY") + '.xlsx',
                periode: moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY"),
                downloadedAt: moment().format('DD MMM YYYY HH:mm:ss'),
                percentage: 0,
                type: 'excel',
            }
            this.$store.commit('report/saveProgress', downloadProgress)

            let percentage = 0
            let intervalDownload = setInterval(() => {
                if (percentage < 75) {
                    percentage += 25
                } else if (percentage == 75) {
                    percentage = 90
                } else if (percentage == 90) {
                    clearInterval(intervalDownload)
                }
                this.$store.commit('report/updateProgress', {
                    progress: downloadProgress,
                    percentage: percentage,
                })
            }, 500)

            let self = this
            this.$apollo
                .query({
                    query: EXPORT_EXCEL_REPORT_VEHICLE_OUTSIDE_GEOFENCE,
                    variables: {
                        filter: filterVar,
                    },
                    fetchPolicy: 'no-cache',
                })
                .then((res) => {
                    let isSuccessful = res.data.excelReportSummaryVehicleOutsideGeofence.isSuccessful
                    if (isSuccessful) {
                        clearInterval(intervalDownload)
                        self.$parent.$parent.$parent.refreshDownloadHistory()
                        setTimeout(() => {
                            self.$store.commit('report/updateProgress', {
                                progress: downloadProgress,
                                percentage: 100,
                            })
                            self.$store.commit('report/deleteProgress', downloadProgress)
                        }, 500)
                    } else {
                        clearInterval(intervalDownload)
                        self.$parent.$parent.$parent.refreshDownloadHistory()
                        setTimeout(() => {
                            self.$store.commit('report/updateProgress', {
                                progress: downloadProgress,
                                percentage: 90,
                            })
                            self.$store.commit('report/deleteProgress', downloadProgress)
                        }, 500)
                    }
                })
        },

        downloadToPdf(periode, filterGeofence, filterVehicle, fields) {
            let filterGeofences = {}
            if (filterGeofence !== undefined && filterGeofence.geofenceId > 0) {
                filterGeofences = {
                    geofenceId: filterGeofence.geofenceId,
                }
            }
            let filterVehicles = {}
            if (filterVehicle !== undefined && filterVehicle.length > 0) {
                filterVehicles = {
                    vehicleId: filterVehicle,
                }
            }
            let filterVar = {
                startDate: moment(periode[0] + ' 00:00:00.000').toISOString(),
                endDate: moment(periode[1] + ' 23:59:59.000').toISOString(),
                column: this.selectValues(fields, 'header'),
                subtitle: `Periode : ${moment(periode[0]).format("DD MMM YYYY")} - ${moment(periode[1]).format("DD MMM YYYY")}`,
                ...filterGeofences,
                ...filterVehicles,
            }

            let downloadProgress = {
                name: 'Kendaraan Keluar Geolokasi ' + moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY") + '.pdf',
                periode: moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY"),
                downloadedAt: moment().format('DD MMM YYYY HH:mm:ss'),
                percentage: 0,
                type: 'pdf',
            }
            this.$store.commit('report/saveProgress', downloadProgress)

            let percentage = 0
            let intervalDownload = setInterval(() => {
                if (percentage < 75) {
                    percentage += 25
                } else if (percentage == 75) {
                    percentage = 90
                } else if (percentage == 90) {
                    clearInterval(intervalDownload)
                }
                this.$store.commit('report/updateProgress', {
                    progress: downloadProgress,
                    percentage: percentage,
                })
            }, 500)

            let self = this
            this.$apollo
                .query({
                    query: EXPORT_PDF_REPORT_VEHICLE_OUTSIDE_GEOFENCE,
                    variables: {
                        filter: filterVar,
                    },
                    fetchPolicy: 'no-cache',
                })
                .then((res) => {
                    let isSuccessful = res.data.pdfReportSummaryVehicleOutsideGeofence.isSuccessful
                    if (isSuccessful) {
                        clearInterval(intervalDownload)
                        self.$parent.$parent.$parent.refreshDownloadHistory()
                        setTimeout(() => {
                            self.$store.commit('report/updateProgress', {
                                progress: downloadProgress,
                                percentage: 100,
                            })
                            self.$store.commit('report/deleteProgress', downloadProgress)
                        }, 500)
                    } else {
                        clearInterval(intervalDownload)
                        self.$parent.$parent.$parent.refreshDownloadHistory()
                        setTimeout(() => {
                            self.$store.commit('report/updateProgress', {
                                progress: downloadProgress,
                                percentage: 90,
                            })
                            self.$store.commit('report/deleteProgress', downloadProgress)
                        }, 500)
                    }
                })
        },
        chunkedVisitedGeofence(visitedGeofence) {
            const chunks = visitedGeofence ? visitedGeofence.split(',') : []
            const maxLength = 5
            const result = []

            for (let i = 0; i < chunks.length; i += maxLength) {
                const chunk = chunks.slice(i, i + maxLength).join(',')
                result.push(chunk)
            }

            return result
        },
    },
}
</script>
